import React, { useEffect } from 'react';
import { Menu } from 'antd';
import { NavLink as Link } from 'react-router-dom';
import SubMenu from 'antd/lib/menu/SubMenu';

export const AccountDasboard = ({ isAuthenticated = false }, props: any) => {
  return (
    <Menu theme="dark" id="ecole-menu" data-cy="ecoleMenu">
      <SubMenu title="Gestion Transactions">
        {isAuthenticated && (
          <>
            <Menu.Item>
              <Link to="/virements">Transactions</Link>
            </Menu.Item>
            <Menu.Item>
              <Link to="/approvisonnements">Approvisonnements</Link>
            </Menu.Item>
          </>
        )}
      </SubMenu>
    </Menu>
  );
};

export default AccountDasboard;
